<template>
  <div class="store-incentive">
    <NavHeaderBar :navBarTitle="$t('shared.storeIncentive')" :isShowLogo="false">
      <div v-if="customerInfo.isAllot === 1" class="right-header" @click="handleOper">
        <img class="icon-img" src="@/assets/images/event_user.png" alt="">
      </div>
    </NavHeaderBar>
    <div class="store-info" @click="toUrl">
      <img src="@/assets/images/store.png" class="row-icon" />
      <span class="store-name van-ellipsis">{{ customerInfo.customerName }}</span>
    </div>
    <div class="tabs-content">
      <div class="tab-item" :class="{'active-item': tabActive === subItem.value}" v-for="subItem in tabsList" :key="subItem.value" @click="handleTabs(subItem)">{{ subItem.label }}</div>
    </div>
    <IncentiveRecords v-if="tabActive === '1'" :customerId="customerId" :employeeList="employeeList" />
    <AccountManagement v-else-if="tabActive === '2'" :customerId="customerId" :employeeList="employeeList" :customerInfo="customerInfo" />
    <van-dialog v-model="inviteShow" title="" :showConfirmButton="false">
      <div class="invite-dialog-btn">
        <div class="invite-info">{{ $t('shared.titleTwenty') }}.</div>
        <div class="qrcode-section" ref="qrCodeRef"></div>
        <!-- 长按保存到相册 -->
        <div class="mark-tips">{{ $t('tips.messageFour') }}</div>
        <div class="dialog-btn">
          <van-button color="#307bff" class="xu-btn" type="info" @click="inviteShow=false">{{ $t('button.close') }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapState } from 'vuex'
import { arsEmployeeListPageApi, arsActivityQrCodeApi, arsCustomerInfoApi } from '@/api/home'
import QRCode from 'qrcodejs2'
export default {
  components: {
    IncentiveRecords: () => import('./incentiveRecords'),
    AccountManagement: () => import('./accountManagement')
  },
  data () {
    return {
      tabActive: '1',
      tabsList: [
        { label: this.$t('shared.filter.incentiveHistory'), value: '1' }, // 激励记录
        { label: this.$t('shared.filter.accountManagement'), value: '2' } // 账号管理
      ],
      customerId: '',
      employeeList: [],
      inviteShow: false,
      qrcodeUrl: null,
      customerInfo: {}
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    this.customerId = this.$route.query.customerId
    this.getEmployeeData()
  },
  deactivated () {
    this.$destroy()
  },
  methods: {
    handleTabs (params) {
      this.tabActive = params.value
    },
    getEmployeeData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEmployeeListPageApi({ customerId: this.customerId, page: 1, limit: 1000 }).then(res => {
        Toast.clear()
        res.data.list.forEach((subItem) => {
          this.globalData.customerJob.find((paramsItem) => {
            if (subItem.job === paramsItem.label && paramsItem.value) {
              subItem.jobColor = JSON.parse(paramsItem.value).color
              return paramsItem
            }
          })
        })
        this.employeeList = res.data.list
      })
      arsCustomerInfoApi(this.customerId).then(res => {
        this.customerInfo = res.data
      })
    },
    handleOper () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsActivityQrCodeApi(this.customerId).then(res => {
        Toast.clear()
        this.inviteShow = true
        this.$nextTick(() => {
          // console.log('this.$refs.qrCodeRef', this.$refs.qrCodeRef.offsetWidth, this.$refs.qrCodeRef.offsetHeight) // document.getElementById('pageHeader').offsetHeight
          if (this.qrcodeUrl) {
            this.qrcodeUrl.clear()
            this.qrcodeUrl.makeCode(res.data)
          } else {
            this.qrcodeUrl = new QRCode(this.$refs.qrCodeRef, {
              text: res.data,
              width: this.$refs.qrCodeRef.offsetWidth,
              height: this.$refs.qrCodeRef.offsetHeight,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.M
            })
          }
        })
      })
    },
    toUrl () {
      this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${this.customerId}&pageType=incentive`)
    }
  }
}
</script>

<style lang="less" scoped>
.store-incentive {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .store-info {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    padding-top: 16px;
    font-size: 14px;
    color: #307bff;
    .store-name {
      text-decoration: underline;
    }
    .row-icon {
      width: 13px;
      height: 13px;
      margin-right: 6px;
    }
  }
  .tabs-content {
    display: flex;
    align-items: center;
    padding: 16px 10px;
    background-color: #fff;
    .tab-item {
      padding: 5px 16px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: bold;
      font-size: 13px;
    }
    .active-item {
      color: #fff;
      background-color: #307bff;
    }
  }
  .invite-dialog-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    .invite-info {
      text-align: center;
    }
    .qrcode-section {
      width: 230px;
      height: 230px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .mark-tips {
      font-size: 12px;
      color: red;
      margin-bottom: 10px;
    }
    .xu-btn {
      width: 200px;
    }
  }
}
</style>
